module.exports = __webpack_public_path__ + "static/IMG-20200906-WA0038-06d0bfb1cdc24872227796da56f4512c.jpg";